export const reportGroups = [
	{
		key: 'outstandingBalances',
		title: 'Outstanding Balances',
		reports: [
			{
				key: 'outstandingBalance',
				title: 'Outstanding Balance Report',
				isAvailable: true,
				showComingSoon: false,
			},
			{
				key: 'outstandingBalanceSummary',
				title: 'Outstanding Balance Summary Report',
				isAvailable: true,
				showComingSoon: false,
			},
		],
	},
	{
		key: 'invoices',
		title: 'Invoices',
		reports: [
			{
				key: 'invoice',
				title: 'Invoice Report',
				isAvailable: true,
				showComingSoon: false,
			},
			{
				key: 'invoiceMonthlyDetail',
				title: 'Invoice Monthly Detail Report',
				isAvailable: true,
				showComingSoon: true,
			},
			{
				key: 'validationAndOtherDetail',
				title: 'Validation & Other Detail Report',
				isAvailable: true,
				showComingSoon: true,
			},
			{
				key: 'invoiceAdjustment',
				title: 'Adjustment Report',
				isAvailable: true,
				showComingSoon: true,
			},
		],
	},
	{
		key: 'payments',
		title: 'Payments',
		reports: [
			{
				key: 'paymentSummary',
				title: 'Payment Summary Report',
				isAvailable: true,
				showComingSoon: false,
			},
			{
				key: 'monthlyParkingPayment',
				title: 'Monthly Parking Payment Report',
				isAvailable: true,
				showComingSoon: false,
			},
			{
				key: 'paymentReconciliation',
				title: 'Payment Reconciliation Report',
				isAvailable: true,
				showComingSoon: false,
			},
			{
				key: 'cashBasisPayment',
				title: 'Cash Basis Payment Report',
				isAvailable: true,
				showComingSoon: false,
			},
			{
				key: 'tax',
				title: 'Tax Report',
				isAvailable: true,
				showComingSoon: false,
			},
		],
	},
	{
		key: 'dailyReports',
		title: 'Daily Reports',
		reports: [
			{
				key: 'dailyRevenue',
				title: 'Daily Revenue Report',
				isAvailable: true,
				showComingSoon: false,
			},
			{
				key: 'missingDailyRevenue',
				title: 'Missing DR Report',
				isAvailable: true,
				showComingSoon: true,
			},
			{
				key: 'bankReconciliation',
				title: 'Bank Reconciliation Report',
				isAvailable: true,
				showComingSoon: true,
			},
			{
				key: 'salesDetail',
				title: 'Sales Report Detail',
				isAvailable: true,
				showComingSoon: true,
			},
			{
				key: 'ticketReconciliation',
				title: 'Ticket Reconciliation Report',
				isAvailable: true,
				showComingSoon: true,
			},
			{
				key: 'salesReportValDetail',
				title: 'Sales Report Val Detail',
				isAvailable: true,
				showComingSoon: true,
			},
			{
				key: 'salesPaymentDetail',
				title: 'Sales Report Payment Detail',
				isAvailable: true,
				showComingSoon: false,
			},
		],
	},
	{
		key: 'subscriptionActivity',
		title: 'Subscription Activity',
		reports: [
			{
				key: 'subscriptionActivity',
				title: 'Subscription Activity Report',
				isAvailable: true,
				showComingSoon: true,
			},
			{
				key: 'subscriptionActivitySummary',
				title: 'Subscription Activity Summary Report',
				isAvailable: true,
				showComingSoon: true,
			},
		],
	},
	{
		key: 'otherReports',
		title: 'Other Reports',
		reports: [
			{
				key: 'transaction',
				title: 'Transaction Report',
				isAvailable: true,
				showComingSoon: false,
			},
			{
				key: 'signUpTermination',
				title: 'Sign Up / Termination Report',
				isAvailable: true,
				showComingSoon: true,
			},
			{
				key: 'managementSummary',
				title: 'Management Summary Report',
				isAvailable: true,
				showComingSoon: false,
			},
			{
				key: 'facilitySettings',
				title: 'Facility Settings Report',
				isAvailable: true,
				showComingSoon: true,
			},
			{
				key: 'previewAutoInvoice',
				title: 'Preview Auto Invoice Report',
				isAvailable: true,
				showComingSoon: true,
			},
			{
				key: 'leaseManagerAllocation',
				title: 'Lease Manager Allocation Report',
				isAvailable: true,
				showComingSoon: true,
			},
		],
	},
] as const;

export type ReportGroup = (typeof reportGroups)[number];
export type ReportGroupKey = ReportGroup['key'];

export type ReportCatalogEntry = ReportGroup['reports'][number];
export type ReportCatalogKey = ReportCatalogEntry['key'];

export const reportKeysHiddenFromNavigation = [
	'salesDetail',
	'salesPaymentDetail',
	'salesReportValDetail',
	'ticketReconciliation',
] as const satisfies readonly ReportCatalogKey[];

export const isReportHiddenFromNavigation = (reportKey: ReportCatalogKey) =>
	reportKeysHiddenFromNavigation.some((hiddenReportKey) => hiddenReportKey === reportKey);

export type AvailableReport = Extract<ReportCatalogEntry, { isAvailable: true }>;
export type AvailableReportKey = AvailableReport['key'];
export const internalReportTypes = [
	'hourlyAccounting',
	'parkerExport',
	'subscriptionExport',
	'ticketReconciliationExport',
	'salesReportExport',
] as const;
export type InternalReportType = (typeof internalReportTypes)[number];
export type ReportType = AvailableReportKey | InternalReportType;
